import React from 'react'
import classNames from 'classnames'
import { WemoloCalendarIcon, WemoloTypography } from '../../../../components/Wemolo'
import { DETECTION_EXPLORER_TEXT, DETECTION_EXPLORER_TIME_PRESETS, TimePreset } from '../../config'
import styles from './TimeFrame.module.css'

export type TimeFrameUIProps = {
    startValue: string
    endValue: string
    minDateTime: string
    maxDateTime: string
    onStartChange: (value: string) => void
    onEndChange: (value: string) => void
    preset: TimePreset
    onPresetChange: (preset: TimePreset) => void
}

export const TimeFrameUI: React.FC<TimeFrameUIProps> = ({
    startValue,
    endValue,
    minDateTime,
    maxDateTime,
    onStartChange,
    onEndChange,
    preset,
    onPresetChange
}) => (
    <div className={styles.timeFrame}>
        <div className={styles.presetGroup} role="group" aria-label={DETECTION_EXPLORER_TEXT.timeFrame.rangeLabel}>
            {DETECTION_EXPLORER_TIME_PRESETS.map((p) => (
                <button
                    key={p.key}
                    type="button"
                    aria-pressed={preset === p.key}
                    className={classNames(styles.presetButton, { [styles.presetButtonActive]: preset === p.key })}
                    onClick={() => onPresetChange(p.key)}
                >
                    {p.label}
                </button>
            ))}
            <button
                type="button"
                aria-pressed={preset === 'custom'}
                className={classNames(styles.presetButton, { [styles.presetButtonActive]: preset === 'custom' })}
                onClick={() => onPresetChange('custom')}
            >
                {DETECTION_EXPLORER_TEXT.timeFrame.custom}
            </button>
        </div>

        {preset === 'custom' && (
            <>
                <div className={styles.dateField}>
                    <WemoloTypography variant="label-medium" tag="span" className={styles.dateLabel}>
                        {DETECTION_EXPLORER_TEXT.timeFrame.start}
                    </WemoloTypography>
                    <label className={styles.dateInput}>
                        <WemoloCalendarIcon className={styles.dateInputIcon} />
                        <input
                            type="datetime-local"
                            value={startValue}
                            min={minDateTime}
                            max={maxDateTime}
                            onChange={(e) => onStartChange(e.target.value)}
                            className={styles.dateInputField}
                        />
                    </label>
                </div>
                <div className={styles.dateField}>
                    <WemoloTypography variant="label-medium" tag="span" className={styles.dateLabel}>
                        {DETECTION_EXPLORER_TEXT.timeFrame.end}
                    </WemoloTypography>
                    <label className={styles.dateInput}>
                        <WemoloCalendarIcon className={styles.dateInputIcon} />
                        <input
                            type="datetime-local"
                            value={endValue}
                            min={minDateTime}
                            max={maxDateTime}
                            onChange={(e) => onEndChange(e.target.value)}
                            className={styles.dateInputField}
                        />
                    </label>
                </div>
            </>
        )}
    </div>
)
